

const ListTemplatesItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default ListTemplatesItemSchema
